import React from "react";
import { Button, IconButton, styled } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { useTranslation } from "react-i18next";

const PREFIX = "ImageDesign";

const classes = {
  root: `${PREFIX}-root`,
  imageDesignTitle: `${PREFIX}-imageDesignTitle`,
  addImageButton: `${PREFIX}-addImageButton`,
  imgFormat: `${PREFIX}-imgFormat`,
  designContainer: `${PREFIX}-designContainer`,
  editImageButton: `${PREFIX}-editImageButton`,
};

const StyledDiv = styled("div")(({ theme }) => {
  return {
    [`& .${classes.root}`]: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      width: "100%",
    },
    [`& .${classes.imageDesignTitle}`]: {
      color: "black",
      fontSize: "24px",
      maxWidth: "650px",
      width: "60%",
      margin: "0 auto",
      textAlign: "center",
      backgroundColor: theme.palette.primary.main,
    },
    [`& .${classes.designContainer}`]: {
      position: "relative",
      width: "100%",
      maxWidth: "650px",
    },
    [`& .${classes.addImageButton}`]: {
      width: "150px",
    },
    [`& .${classes.editImageButton}`]: {
      backgroundColor: "white",
      color: "#D3AF5F",
      borderRadius: "50%",
      width: "34px",
      height: "34px",
      position: "absolute",
      top: "10px",
      right: "10px",
    },
    [`& .${classes.imgFormat}`]: {
      width: "100%",
      maxWidth: "650px",
    },
  };
});

export default function ImageDesign(props) {
  const { t } = useTranslation();

  return (
    <StyledDiv>
      <div className={classes.root}>
        {props.imageUrl && props.canUserModifyData ? (
          <div className={classes.designContainer}>
            <IconButton
              component="label"
              variant="outlined"
              className={classes.editImageButton}
              onChange={(e) => {
                props.updateData("myDesign", "imgUrl", e.target.files[0]);
              }}
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <EditIcon />
              <input type="file" accept="image/*" hidden />
            </IconButton>
            <img
              src={
                typeof props.imageUrl === "string"
                  ? props.imageUrl
                  : URL.createObjectURL(props.imageUrl)
              }
              alt="myDesign"
              className={classes.imgFormat}
            />
          </div>
        ) : (
          <Button
            component="label"
            variant="outlined"
            disabled={!props.canUserModifyData}
            className={classes.addImageButton}
            onChange={(e) => {
              props.updateData("myDesign", "imgUrl", e.target.files[0]);
            }}
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            {t("Crm.buttons.addImage")}
            <input type="file" accept="image/*" hidden />
          </Button>
        )}
      </div>
    </StyledDiv>
  );
}
